module.exports = __webpack_public_path__ + "img/checkApp6.1ca7c639.png";